module.exports = flarum.reg.get('v17development-seo', 'forum');